<div class="side-menu-container">
  <div class="main-side-menu-background">
    <div class="main-side-menu">
      <div class="logo-text-container">
        <div class="logo-container">
          <img [src]="'images/browsi-logo.png' | assetVersion">
        </div>
        <div class="text-container">
          InsightHub
        </div>
      </div>
      <div class="side-menu-button copilot"
        [ngClass]="{ active: isActiveRoute(RoutePaths.POLARIS), disabled: !!disabledTabs.polaris }"
        (mouseenter)="(isCopilotHovered = true)" (mouseleave)="(isCopilotHovered = false)"
        (click)="navigateIfEnabled(RoutePaths.POLARIS)">
        <app-coming-soon class="coming-soon-tooltip" [isVisible]="disabledTabs.polaris &&isCopilotHovered" />
        <img [src]="'svg/copilot-star.svg' | assetVersion">
        POLARIS™
        <div class="copilot-beta">
          <span>Beta</span>
        </div>
      </div>
      @if (shouldDisplaySignals){
       <ng-container *ngTemplateOutlet="sideMenuButtonTemplate; context: { config: signalsPageConfig }"></ng-container>
      }
      <!--      hidden until connected to polaris-->
<!--      <div-->
<!--        [matTooltip]="disabledTabs[signalsPageConfig.route] ? tooltips.unauthorizedTab : null"-->
<!--        matTooltipClass="tooltip-with-triangle"-->
<!--        class="side-menu-button"-->
<!--        [ngClass]="{ active: isActiveRoute(signalsPageConfig.route), disabled: disabledTabs[signalsPageConfig.route]}"-->
<!--        (click)="navigateIfEnabled(signalsPageConfig.route)">-->
<!--        <img [src]="signalsPageConfig.icon">-->
<!--        {{ signalsPageConfig.text }}-->
<!--      </div>-->
      <div class="divider"></div>
      @for (config of firstSectionRouteConfigs; track config) {
        <ng-container *ngTemplateOutlet="sideMenuButtonTemplate; context: { config: config }"></ng-container>
      }
      <div class="divider"></div>
      @for (config of secondSectionRouteConfigs; track config) {
        <ng-container *ngTemplateOutlet="sideMenuButtonTemplate; context: { config: config }"></ng-container>
      }
      <div class="divider"></div>
      @for (config of thirdSectionRouteConfigs; track config) {
        <ng-container *ngTemplateOutlet="sideMenuButtonTemplate; context: { config: config }"></ng-container>
      }
      @if (userGivenName && userFamilyName) {
      <div data-testid="sidebar-user-menu-button" class="side-menu-button user" #trigger="cdkOverlayOrigin"
        cdkOverlayOrigin (click)="openProfileScreen()">
        <img [src]="'svg/user-circle.svg' | assetVersion">
        <div class="user-name">
          {{ userGivenName }}
          <br>
          {{ userFamilyName }}
        </div>
      </div>
      <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="isProfileOpen"
        [cdkConnectedOverlayHasBackdrop]="true" [cdkConnectedOverlayBackdropClass]="'transparent-backdrop'"
        [cdkConnectedOverlayPositions]="profilePositions" (backdropClick)="isProfileOpen = false"
        (cdkConnectedOverlayKeydown)="onKeyDown($event)">
        <app-profile (manageAccountsClicked)="navigate(RoutePaths.MANAGE)"></app-profile>
      </ng-template>
      }
    </div>
  </div>
</div>

<ng-template #sideMenuButtonTemplate let-config="config">
  <div
    class="side-menu-button"
    [ngClass]="{ 'active': isActiveRoute(config.route), 'disabled': config.disable, 'coming-soon': config.comingSoon }"
    (mouseenter)="(hoveredMap[config.route] = true)"
    (mouseleave)="(hoveredMap[config.route] = false)"
    (click)="navigateIfEnabled(config.route)"
    [tp]="config.premiumBadge ? PremiumTooltipTemplate : null" [tpClassName]="'custom-tooltip'" [tpPlacement]="'bottom'">
    <img [src]="config.icon | assetVersion">
    {{ config.text }}
    @if (config.premiumBadge) {
      <img [src]="'svg/premium-badge.svg' | assetVersion">
    }
    @if (config.comingSoon) {
      <app-coming-soon class="coming-soon-tooltip" [isVisible]="hoveredMap[config.route]" />
    }
  </div>
</ng-template>

<ng-template #PremiumTooltipTemplate>
  <app-premium-tooltip [text]="tooltips.premium.sideMenuTab" [width]="'258px'"></app-premium-tooltip>
</ng-template>
